import {
  SearchInvoicesResponse,
  CursorSearch,
} from './src/invoices-invoices-v4-invoice-invoices.universal';

export * from './src/invoices-invoices-v4-invoice-invoices.universal.js';

/** @hidden */
export type InvoiceSearch = {};

/**
 * Retrieves a list of up to 100 invoices, given the provided filtering, search expression, sorting, and cursor paging.
 *
 *
 * Unlike [Query Invoices], Search Invoices supports free-text search across fields like `title`, `numbering.displayNumber`, and customer contact details. It also returns aggregation data.
 * @param search - Search options.
 * @public
 * @documentationMaturity preview
 * @requiredField search
 * @permissionId INVOICES.INVOICE_READ
 * @applicableIdentity APP
 * @fqn wix.invoices.invoices.v4.Invoices.SearchInvoices
 */
export declare function searchInvoices(
  search: CursorSearch
): Promise<SearchInvoicesResponse>;
